import { ReactNode } from "react"
import cn from "classnames"

interface SubmenuProps {
    children: ReactNode
    className?: string
}

export function Submenu(props: SubmenuProps) {
    return (
        <div className="desktop-navigation-item-submenu-wrapper">
            <div className={cn("desktop-navigation-submenu", props.className)}>
                {props.children}
            </div>
        </div>
    )
}
